import React, { useState, useEffect } from "react";
// @material-ui/core components
import { Grid, Tabs, Tab } from "@material-ui/core";
// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import tableStyles from "../../../../assets/jss/components/tableStyle";
import styles from "../../../../assets/jss/layouts/appStyle";
// core components
import { LOCALE } from "../../../../properties/Locale";
import AwardRecognitionTypeComponent from "./awardRecognition/AwardRecognitionComponent";
import AwardLevelComponent from "./awardLevel/AwardLevelComponent";
import AwardTypeComponent from "./awardType/AwardTypeComponent";
import AwardSchemaPointComponent from "./awardSchemaPoint/AwardSchemaPointComponent";

const useStyles = makeStyles(styles, tableStyles);

export default function AwardsAndRecognitionConfigComponent(props) {
  const classes = useStyles();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };

  return (
    <div>
      <Grid container style={{ paddingTop: "25px" }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label={LOCALE.award_recognition} />
          <Tab label={LOCALE.award_level} />
          <Tab label={LOCALE.award_type} />
          <Tab label={LOCALE.schema_points} />
        </Tabs>
        {tabIndex === 0 && (
          <AwardRecognitionTypeComponent
            gradingSchemaId={props.gradingSchemaId}
          />
        )}
        {tabIndex === 1 && (
          <AwardLevelComponent gradingSchemaId={props.gradingSchemaId} />
        )}
        {tabIndex === 2 && (
          <AwardTypeComponent gradingSchemaId={props.gradingSchemaId} />
        )}
        {tabIndex === 3 && (
          <AwardSchemaPointComponent gradingSchemaId={props.gradingSchemaId} />
        )}
      </Grid>
    </div>
  );
}
